import { createContext, ReactNode, useCallback, useContext, useState } from "react";
import { Theme } from "./types";

export const ThemeContext = createContext<Theme>("dark");
export const ThemeUpdateContext = createContext<(theme: Theme) => void>((...args) => { });

export function useTheme() {
  return useContext(ThemeContext);
}

export function useThemeUpdate() {
  return useContext(ThemeUpdateContext);
}

type Props = {
  children?: ReactNode;
};

export function ThemeProvider(props: Props) {
  const { children } = props;
  const [theme, setTheme] = useState<Theme>("dark");

  const changeTheme = useCallback((value: Theme) => {
    setTheme(value);
  }, []);

  return (
    <ThemeContext.Provider value={theme}>
      <ThemeUpdateContext.Provider value={changeTheme}>{children}</ThemeUpdateContext.Provider>
    </ThemeContext.Provider>
  );
}
